module.exports = __webpack_public_path__ + "officialStatic/img/case6.633b727.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case6.png
// module id = U/NO
// module chunks = 0